import type { InputHTMLAttributes, ReactNode } from 'react';
import { m } from 'motion/react';
import { Loader2 } from 'lucide-react';

const EASE = [0.16, 1, 0.3, 1] as const;

/** Card centralizado das telas de auth: logo + marca + conteúdo, com entrada fade+slide. */
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-4 py-8">
      <m.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.28, ease: EASE }}
        className="w-full max-w-[400px] rounded-xl bg-surface p-8 shadow-card"
      >
        <div className="flex flex-col items-center text-center">
          <div className="grid size-11 place-items-center rounded-2xl bg-primary text-lg font-bold text-white">
            L
          </div>
          <h1 className="mt-3 text-2xl font-bold text-ink">Lira</h1>
          <p className="mt-1 text-sm text-muted">Organizador financeiro</p>
        </div>
        {children}
      </m.div>
    </div>
  );
}

type FieldProps = { label: string; id: string } & InputHTMLAttributes<HTMLInputElement>;

/** Campo padrão das telas de auth: label 13px cinza + input h-11 com foco roxo. */
export function AuthField({ label, id, ...input }: FieldProps) {
  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-[13px] text-muted">
        {label}
      </label>
      <input
        id={id}
        {...input}
        className="h-11 w-full rounded-lg border border-field bg-surface px-3 text-[15px] text-ink transition-colors focus:border-primary focus:outline-none"
      />
    </div>
  );
}

/** Botão principal (pill roxa, uppercase) com estado de loading. */
export function AuthSubmit({ loading, children }: { loading: boolean; children: ReactNode }) {
  return (
    <button
      type="submit"
      disabled={loading}
      className="flex h-11 w-full items-center justify-center gap-2 rounded-full bg-primary font-semibold tracking-wide text-white transition-colors hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60"
    >
      {loading && <Loader2 className="size-4 animate-spin" />}
      {children}
    </button>
  );
}
